import Logger from './logger';
import _ from './underscore';

/**
 * Created by andreyna on 6/9/2016.
 */
/**
 * Loader of the modules
 *
 */

class Loader {
    logger;

    /**
     * @constructor
     */
    constructor() {
        this.logger = new Logger('LOADER', window.LOG_LEVEL);
    }

    /**
     * Convert the require in to the default export
     *
     * @throws {Error} - if the instance not contain default export
     * @throws {Error} - if the class in the instance not contain static CLASS
     * @param req - the request instance to module
     * @returns {*} - the default class in the require file
     * @public
     */
    getDefault(req) {
        return req.keys().map((name)=> {
            let obj = req(name);
            if (_.isUndefined(obj.default)) {
                this.logger.error('module doesn\'t contain default => ' + name);
                throw new Error('module doesn\'t contain default => ' + name);
            }
            if (_.isUndefined(obj.default.CLASS)) {
                this.logger.error('class doesn\'t contain CLASS => ' + name);
                throw new Error('class doesn\'t contain CLASS => ' + name);
            }
            this.logger.debug('loader - append => ' + obj.default.CLASS);
            return obj.default;
        });
    }

    /**
     * Get the services class
     *
     * @returns {*} - the services class
     * @public
     */

    services() {
        let req = require.context('../services', true, /^.*(service)\.(js|ts)$/);
        return this.getDefault(req);
    }

    /**
     * Get the option components class
     * @function
     * @returns {*} - the module class
     * @public
     */
    optionComponents() {
        let req = require.context('../components/options/option_components', true, /^.*(controller)\.js$/);
        return this.getDefault(req);
    }

    /**
     * Don't use this method. It used by ExperimentalService only
     * @returns {*}
     */
    components() {
        let req = require.context('../components', true, /^.*(controller)\.js$/);
        return this.getDefault(req);
    }

}

export default Loader;